import React from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import axios from "axios";
import API from "../helpers/api";
import { toast } from "react-toastify";
import {
  getClientManagementDetails,
  getClientManagementList,
  getClientList,
} from "../Actions/ClientManagementAPI";
import { normalizeClientRecord } from "../helpers/clientManagementNormalize";
import ClientContactUsersReadOnly from "./ClientContactUsersReadOnly";
import "./UserManagementMaster.css";

const currentUser = JSON.parse(localStorage.getItem("currentUser"));

const defaultSearchData = {
  CompanyName: "",
  Mail: "",
  Phone: "",
  ClientType: "",
  PageNumber: 1,
  PageSize: 15,
};

class ClientManagementDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      clientUsers: [],
      usersLoading: false,
    };
  }

  componentDidMount() {
    const { match, dispatch } = this.props;
    dispatch(getClientManagementDetails(match.params.id));
    this.loadClientUsers(match.params.id);
  }

  componentDidUpdate(prevProps) {
    const { match, dispatch } = this.props;
    if (match.params.id !== prevProps.match.params.id) {
      dispatch(getClientManagementDetails(match.params.id));
      this.loadClientUsers(match.params.id);
    }

    window.onpopstate = () => {
      this.props.dispatch({ type: "ShowSidePan", data: false });
      this.props.history.push("/Home/ClientManagement");
    };
  }

  loadClientUsers(clientId) {
    if (!clientId) {
      this.setState({ clientUsers: [], usersLoading: false });
      return;
    }

    this.setState({ usersLoading: true });

    axios
      .get(`${API.getClientUsers}?clientId=${clientId}`)
      .then((response) => {
        this.setState({
          clientUsers: Array.isArray(response.data) ? response.data : [],
          usersLoading: false,
        });
      })
      .catch(() => {
        this.setState({ clientUsers: [], usersLoading: false });
      });
  }

  hideSidePanel = () => {
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.history.push("/Home/ClientManagement");
  };

  getClientTypeLabel(clientType, t) {
    if (!clientType) {
      return "-";
    }
    const normalized = clientType.toLowerCase();
    if (normalized === "owner") {
      return t("ClientManagementScreenContent.Owner");
    }
    if (normalized === "management company") {
      return t("ClientManagementScreenContent.ManagementCompany");
    }
    return clientType;
  }

  EditClientDetails() {
    const { history, dispatch, match } = this.props;
    dispatch({ type: "ShowSidePan", data: false });
    history.push(`/Home/ClientManagement/Edit/${match.params.id}`);
    window.scrollTo(0, 0);
  }

  deleteClientDetails() {
    const { t, ClientDetails, history, dispatch } = this.props;

    confirmAlert({
      message: `${t("confirmAlertMessage.DeleteMsg")}`,
      buttons: [
        {
          label: `${t("confirmAlertMessage.Yes")}`,
          onClick: () => {
            const client = normalizeClientRecord(ClientDetails);
            const payload = {
              clientId: client.clientId,
              companyName: client.companyName,
              mail: client.mail,
              address: client.address,
              telephone: client.telephone,
              clientType: client.clientType,
              isDeleted: true,
              modifiedBy: currentUser?.name || "",
            };

            axios
              .put(API.getClientDetails, payload, {
                headers: { key: currentUser.accessToken },
              })
              .then(() => {
                dispatch(getClientManagementList(defaultSearchData));
                dispatch(getClientList());
                dispatch({ type: "ShowSidePan", data: false });
                history.push("/Home/ClientManagement");
                toast.success(t("CommonText.CommonDelete"));
              })
              .catch(() => {
                toast.error(t("CommonText.500ErrorMessage"));
              });
          },
        },
        {
          label: `${t("confirmAlertMessage.No")}`,
        },
      ],
    });
  }

  renderDetailField(label, value, iconClass, fullWidth = false) {
    return (
      <div className={`um-detail-field${fullWidth ? " um-detail-field-full" : ""}`}>
        <span className="um-field-label um-list-label">
          <i className={`fa ${iconClass} um-list-label-icon`} aria-hidden="true"></i>
          <span>{label}</span>
        </span>
        <div className="um-detail-value">{value || "-"}</div>
      </div>
    );
  }

  getClientTypeBadgeClass(clientType) {
    if (!clientType) {
      return "um-role-badge";
    }
    const normalized = clientType.toLowerCase();
    if (normalized === "owner") {
      return "um-role-badge um-client-type-owner";
    }
    if (normalized === "management company") {
      return "um-role-badge um-client-type-mgmt";
    }
    return "um-role-badge";
  }

  render() {
    const { ClientDetails, t } = this.props;
    const { clientUsers, usersLoading } = this.state;
    const client = normalizeClientRecord(
      ClientDetails && typeof ClientDetails === "object" ? ClientDetails : {}
    );

    return (
      <div className="full-height user-module-master um-sidepane-detail">
        <div className="um-sidepane-detail-inner">
          <button
            type="button"
            className="btn btn-primary text-uppercase txtside-btn txtht-btn blue um-return-btn"
            onClick={this.hideSidePanel}
          >
            <span>&larr;</span>
            {t("CommonText.Return")}
          </button>

          <div className="um-section">
            <div className="um-section-header">
              <h5 className="um-section-title">
                <i className="fa fa-eye um-section-title-icon" aria-hidden="true"></i>
                {t("ClientManagementScreenContent.ViewDetails")}
              </h5>
            </div>
            <div className="um-section-body">
              <div className="um-detail-grid">
                {this.renderDetailField(
                  t("ShipManagementContent.CompanyName"),
                  client.companyName,
                  "fa-institution"
                )}
                {this.renderDetailField(
                  t("ServicedByScreenContent.Email"),
                  client.mail,
                  "fa-envelope-o"
                )}
                {this.renderDetailField(
                  t("ClientManagementScreenContent.Phone"),
                  client.telephone,
                  "fa-phone"
                )}
                {this.renderDetailField(
                  t("ClientManagementScreenContent.Address"),
                  client.address,
                  "fa-map-marker"
                )}
                <div className="um-detail-field um-detail-field-full">
                  <span className="um-field-label um-list-label">
                    <i className="fa fa-briefcase um-list-label-icon" aria-hidden="true"></i>
                    <span>{t("ClientManagementScreenContent.Owner/ManagementCompany")}</span>
                  </span>
                  <div className="um-detail-value">
                    <span className={this.getClientTypeBadgeClass(client.clientType)}>
                      {this.getClientTypeLabel(client.clientType, t)}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <ClientContactUsersReadOnly users={clientUsers} loading={usersLoading} />

          <div className="um-form-actions um-sidepane-actions">
            <button
              type="button"
              className="btn btn-primary text-uppercase um-btn um-btn-primary"
              onClick={() => this.EditClientDetails()}
            >
              {t("IntervelScreen.Edit")}
            </button>
            <button
              type="button"
              className="btn btn-light text-uppercase um-btn um-btn-secondary"
              onClick={() => this.deleteClientDetails()}
            >
              {t("CommonText.Delete")}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

function mapStateToProps(state) {
  return {
    ClientDetails: state.MasterScreenReducer.ClientManagementDetails,
  };
}

export default withTranslation()(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(ClientManagementDetail))
);
